import { render, staticRenderFns } from "./TopSix.vue?vue&type=template&id=1e8c9112&scoped=true&"
import script from "./TopSix.vue?vue&type=script&lang=js&"
export * from "./TopSix.vue?vue&type=script&lang=js&"
import style0 from "./TopSix.vue?vue&type=style&index=0&id=1e8c9112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8c9112",
  null
  
)

export default component.exports